<ng-template #content let-modal>
    <div class="modal-header">
        <h4>{{modalHeader}}</h4>
    </div>

    <div class="modal-body">
      <div class="col-md-7 mb-3">
        <div class="detail-name">Class Name *</div>
        <input class="form-control" [(ngModel)]="data.Description">
      </div>
      
      <div class="col-md-12 mb-3">
        <div class="detail-name">Class Code</div>
        <div class="d-flex">
          <input [class.invalid]="loginCodeTaken" class="form-control col-md-7" placeholder="Leave blank to auto-generate or enter text to customize" [(ngModel)]="newLoginCode" (keyup)="triggerCheckLoginCode(newLoginCode)">
          <div class="col-md-5" *ngIf="loginCodeTaken === undefined"><app-loading-spinner text="Checking..."></app-loading-spinner></div>
        </div>
        <div *ngIf="loginCodeTaken" class="error-message">That class code is taken. Try another.</div>
      </div>
      
      <div class="col-md-3 mb-3">
        <div class="detail-name">Start</div>
        <app-datepicker [(model)]="data.ClassSection.StartingOn">
        </app-datepicker>
      </div>
      <div class="col-md-3 mb-5">
        <div class="detail-name">End</div>
        <app-datepicker [(model)]="data.ClassSection.Ending">
        </app-datepicker>
      </div>
      <span class="col-md-3">* Required</span>
    </div>

    <div class="modal-footer" style="border: none">
        <button *ngIf="!isWaiting" type="button" class="btn btn-outline-secondary btn-lg"
            (click)="modal.dismiss('Cross click')">Cancel</button>
        <button *ngIf="!isWaiting" [disabled]="!isInputValid()" type="button" class="btn btn-primary btn-lg"
            (click)="modalSubmitted()">{{submitButtonText}}</button>
        <app-loading-spinner *ngIf="isWaiting"></app-loading-spinner>
    </div>

</ng-template>

<button *ngIf="openModalButtonVisible" class="btn btn-primary" (click)="openForNew()">+ ADD CLASS</button>
